import type { ButtonHTMLAttributes, FC } from 'react';
import cx from 'classnames';

import styles from './UnstyledButton.module.css';

type Props = ButtonHTMLAttributes<HTMLButtonElement>;

export const UnstyledButton: FC<Props> = ({ className, type = 'button', children, ...props }) => (
  <button
    type={type}
    {...props}
    className={cx(styles.root, className)}
  >
    {children}
  </button>
);
